exports.onClientEntry = () => {
  window.addEventListener('load', function () {
    initialiseWebToApp()
  })
}

const initialiseWebToApp = () => {
  const url = new URL(window.location)
  const searchParams = url.searchParams
  const paramsList = ['gclid', 'gbraid', 'fbclid', 'fbpid', 'cks', 'ttclid']

  for (let i = 0; i < paramsList.length; i++) {
    let param = paramsList[i]
    if (searchParams.has(param)) {
      let obj = {}
      obj[param] = searchParams.get(param)
      findLinksAndAddQueryParams('[href^="https://app.adjust.com"]', obj)
    }
  }
}

const findLinksAndAddQueryParams = (selector, params) => {
  let queryParams = Object.keys(params)
    .reduce(function (accumulator, param) {
      accumulator.push(param + '=' + params[param])
      return accumulator
    }, [])
    .join('&')

  Array.prototype.slice
    .call(document.querySelectorAll(selector))
    .forEach(function (node) {
      let href = node.href
      let hasQueryParams = href.indexOf('?') > -1
      node.setAttribute(
        'href',
        href + (hasQueryParams ? '&' : '?') + queryParams,
      )
    })
}
